/**
 * Dark / light theme toggle backed by `useTheme`.
 */
import { Moon, Sun } from "lucide-react";
import { useTheme } from "../state/theme";

export const ThemeToggle: React.FC<{ className?: string }> = ({ className = "" }) => {
  const isDark = useTheme((s) => s.isDark);
  const toggle = useTheme((s) => s.toggle);
  return (
    <button
      type="button"
      onClick={toggle}
      aria-pressed={isDark}
      title={isDark ? "Switch to light mode" : "Switch to dark mode"}
      className={`btn ${className}`}
    >
      {isDark ? <Moon className="h-4 w-4" /> : <Sun className="h-4 w-4" />}
      <span className="hidden sm:inline">{isDark ? "Dark" : "Light"}</span>
    </button>
  );
};
